module.exports = __webpack_public_path__ + "static/media/fwdfwd-dark.1095ce2d.svg";